const SVGDefault = (props: any) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
      {...props}
    >
      <g clipPath="url(#clip0_479_2315)">
        <path
          d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
          fill="#EF8E20"
        />
        <g clipPath="url(#clip1_479_2315)">
          <path
            d="M14.7618 11.2921C14.557 11.1022 14.2411 11.1146 14.0256 11.2921L12.4325 12.6031C12.2382 12.7638 11.9939 12.8516 11.7418 12.8513H9.70077C9.63087 12.8433 9.56629 12.81 9.51913 12.7578C9.47197 12.7056 9.44546 12.638 9.44457 12.5676C9.44457 12.4238 9.55424 12.3024 9.7009 12.2837H11.0512C11.3359 12.2843 11.579 12.0843 11.6249 11.8118C11.6814 11.4568 11.4144 11.1484 11.0803 11.1484H8.31946C7.85208 11.1491 7.39987 11.3143 7.04224 11.6153L6.24185 12.2837H5.28289C5.12547 12.2877 5.00123 12.4149 5.00529 12.5675V14.2704C5.00123 14.4223 5.12446 14.5492 5.28112 14.554H11.4386C11.6906 14.5537 11.9347 14.466 12.1293 14.3058L14.7382 12.1594C14.8011 12.1067 14.8522 12.0412 14.888 11.9673C14.9238 11.8934 14.9437 11.8128 14.9461 11.7308C14.9482 11.6488 14.9328 11.5673 14.901 11.4916C14.8692 11.416 14.8217 11.348 14.7618 11.2921Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.025 7.11735V7.13292C14.025 7.1485 14.025 7.15629 14.0328 7.17186V7.17965V10.801C14.0328 10.8945 13.9784 10.9724 13.9008 11.0113L12.253 11.8301C12.2802 11.7331 12.2982 11.6227 12.2982 11.5002C12.2982 11.0002 11.4982 10.5002 10.9997 10.5002H8.46967C8.15918 10.5002 7.85362 10.5725 7.5759 10.7114L7.06177 10.9684C7.02139 10.9249 7 10.8669 7 10.8088V7.17965V7.17186C7 7.16407 7.00194 7.15823 7.00388 7.15239C7.00582 7.14655 7.00776 7.14071 7.00776 7.13292V7.11735C7.00776 7.10177 7.01552 7.08621 7.02327 7.07064L7.02328 7.07062V7.06283C7.03104 7.05505 7.03685 7.04727 7.04266 7.0395C7.04849 7.0317 7.05432 7.0239 7.0621 7.0161L7.06986 7.00831C7.07374 7.00442 7.07955 7.00053 7.08537 6.99664C7.09119 6.99275 7.09702 6.98885 7.10089 6.98495L7.10867 6.97716H7.11644L7.1242 6.96937L8.4671 6.29961L8.47485 6.3074L11.8282 8.0441V9.81196C11.8282 9.82752 11.8282 9.84309 11.836 9.85091C11.8593 9.88985 11.9059 9.90542 11.9446 9.88204L12.6123 9.53158C12.6355 9.51601 12.6511 9.49263 12.6511 9.4615V7.65471V7.64693V7.63135C12.6471 7.62743 12.6452 7.62352 12.6432 7.61961C12.6413 7.61574 12.6394 7.61186 12.6355 7.60798C12.6316 7.60798 12.6297 7.60604 12.6278 7.60409C12.6258 7.60214 12.6239 7.60019 12.62 7.60019L12.6123 7.59241L9.29767 5.88685L10.4077 5.33391C10.4776 5.30276 10.5552 5.30276 10.6173 5.33391L13.9163 6.97716L13.9241 6.98495H13.9319L13.9396 6.99274C13.9435 6.99665 13.9494 7.00055 13.9552 7.00446C13.961 7.00834 13.9668 7.01222 13.9707 7.0161L13.9784 7.02389L13.9786 7.02406C13.9864 7.03189 14.0018 7.04736 14.0095 7.06283V7.07062C14.0134 7.0784 14.0153 7.08619 14.0172 7.09398C14.0192 7.10177 14.0211 7.10956 14.025 7.11735Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_479_2315">
          <rect width="20" height="20" fill="white" />
        </clipPath>
        <clipPath id="clip1_479_2315">
          <rect width="10" height="10" fill="white" transform="translate(5 5)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default SVGDefault
